<template>
  <div class="segbar"></div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array
    },
    options: {
      type: Object
    },
    type: {
      type: String
    }
  },
  data () {
    return {
      device: 'mobile'
    }
  },
  methods: {
    /* eslint-disable */
    constructBar(element) {
      let percentages = this.getPercentages(this.data);

      for (let i = 0; i < this.data.length; i++) {
        this.data[i].percent = +percentages[i];
      }

      // Percent 계산문
      let totalPercent = 0;
      for (let i = this.data.length - 1; i >= 0; i--) {
        let percent = 0;
        if (i !== 0) {
          if (parseFloat(this.data[i].percent * 100) < 10) {
            totalPercent += 10;
            this.data[i].percent = 10;
          } else {
            percent = parseInt(this.data[i].percent * 100);
            this.data[i].percent = percent;
            totalPercent += percent;
          }
        } else {
          this.data[i].percent = 100 - Number(totalPercent);
        }
      }

      Object.values(this.data).forEach((item, index) => {
        let div = document.createElement('div');

        // wrapper
        div.style.width = parseInt(item.percent) + '%';
        div.style.backgroundColor = item.color;
        div.classList.add('item-wrapper');

        element.appendChild(div);
      });
    },
    getPercentages(data) {
      let sum = this.getSum(data);

      return data.map(function (item) {
        return parseFloat(item.value / sum);
      });
    },
    getSum(data) {
      return data.reduce(function (sum, item) {
        return sum + item.value;
      }, 0);
    },
    delDiv() {
      let delDiv = document.getElementsByClassName('item-wrapper');
      for (let i = delDiv.length - 1; i >= 0; i--) {
        delDiv[i].remove();
      }
    }
  },
  watch: {
    data() {
      this.delDiv();
      setTimeout(() => {
        this.constructBar(this.$el);
      }, 100);
    }
  },
  mounted() {
    this.constructBar(this.$el);
  }
};
</script>

<style type="css">
/*.segbar{*/
  /*display: block;*/
  /*width: 100%;*/
  /*height: 8px*/
/*}*/

/*.segbar:after{*/
  /*content: "";*/
  /*display: block;*/
  /*clear: both;*/
/*}*/

/*.item-wrapper{*/
  /*float: left;*/
  /*height: 8px;*/
  /*position: relative*/
/*}*/

/*.item-wrapper:first-child{*/
  /*border-radius: 100px 0 0 100px;*/
/*}*/

/*.item-wrapper:last-child{*/
  /*border-radius: 0 100px 100px 0;*/
/*}*/

/*.item-title{*/
  /*top: 12px;*/
  /*position: absolute;*/
  /*color: #777;*/
  /*font-size: 11px;*/
  /*border-bottom: 1px solid #ccc;*/
/*}*/


</style>
